import { createContext, FC, useCallback, useContext, useMemo, useState } from 'react'
import { AppointmentRescheduleFormData } from '../../types'

type RescheduleFormData = Partial<AppointmentRescheduleFormData>

type RescheduleContext = RescheduleFormData & {
  clearContext: () => void
  setContext: (context?: RescheduleFormData) => void
}

const context = createContext<RescheduleContext>({
  clearContext: () => undefined,
  setContext: () => undefined,
})

const { Provider } = context

const RescheduleProvider: FC = ({ children }) => {
  const [formData, setFormData] = useState<RescheduleFormData | undefined>()

  const setFormDataProxy = useCallback(
    (context?: RescheduleFormData) => {
      setFormData(context)
    },
    [setFormData]
  )

  const clearContext = useCallback(() => {
    setFormData(undefined)
  }, [setFormData])

  const value: RescheduleContext = useMemo(
    () => ({ ...formData, clearContext, setContext: setFormDataProxy }),
    [formData, setFormDataProxy]
  )

  return <Provider value={value}>{children}</Provider>
}

const useRescheduleContext = () => useContext(context)

export { RescheduleProvider, useRescheduleContext }
export type { RescheduleContext }
